module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-18-604f3333fe696e3df24eb8c08d72e3cd.jpg";